import ReactImgix, { SharedImigixAndSourceProps } from 'react-imgix';
import { buildHeImgixLQuipUrl, buildHeImgixUrl } from './imgix';

/**
 * Hey! If you are using this component, you should definitely check out
 * https://github.com/imgix/react-imgix#usage
 * and
 * https://ericportis.com/posts/2014/srcset-sizes/
 * in order to reach its full potential!
 */
export const HeImgix = ({
  src,
  htmlAttributes,
  className,
  ...rest
}: SharedImigixAndSourceProps) => (
  <ReactImgix
    src={buildHeImgixUrl(src)}
    htmlAttributes={{
      ...htmlAttributes,
      src: buildHeImgixLQuipUrl(src, rest.imgixParams),
    }}
    {...rest}
    className={`lazyload ${className}`}
    attributeConfig={{
      src: 'data-src',
      srcSet: 'data-srcset',
      sizes: 'data-sizes',
    }}
  />
);
